import { render } from "./LocationBlock.vue?vue&type=template&id=55ac982d&scoped=true"
import script from "./LocationBlock.vue?vue&type=script&lang=js"
export * from "./LocationBlock.vue?vue&type=script&lang=js"

import "./LocationBlock.vue?vue&type=style&index=0&id=55ac982d&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55ac982d"]])

export default __exports__